exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2PPqoqZA83f8jMG67A4dv8{display:inline;width:70%}html[dir=ltr] ._2PPqoqZA83f8jMG67A4dv8{float:left}html[dir=rtl] ._2PPqoqZA83f8jMG67A4dv8{float:right}._3h2MX-8Fm9ey1zqt2i-Vea{font-size:14px;line-height:19px;font-weight:400}._2FAAqjlbPW7T1Zyd1_x591{display:inline}html[dir=ltr] ._2FAAqjlbPW7T1Zyd1_x591{float:right}html[dir=rtl] ._2FAAqjlbPW7T1Zyd1_x591{float:left}", ""]);

// exports
exports.locals = {
	"subscription_text_container": "_2PPqoqZA83f8jMG67A4dv8",
	"premiumDashboard_text_content": "_3h2MX-8Fm9ey1zqt2i-Vea",
	"subscription_btn_container": "_2FAAqjlbPW7T1Zyd1_x591"
};